var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('LoadingSpinner'),_c('topNav',{on:{"openDialog":_vm.openDialog}}),_c('router-view'),_c('part-ten'),_c('service'),_c('index-dialog',{model:{value:(_vm.dialogVisible),callback:function ($$v) {_vm.dialogVisible=$$v},expression:"dialogVisible"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }